/* ==================================================================
   FRANTIC STUDIO - Naechste verfuegbare Groesse, angelegt 2026-10-25
   ------------------------------------------------------------------
   Problem: Wechselt man das Material (z. B. Silber auf Edelstahl), blieb
   die bisherige Groesse ausgewaehlt, auch wenn es sie im neuen Material
   nicht gibt. Der Button stand dann auf "Ausverkauft".

   Loesung: Hat der Kunde eine andere Option als die letzte geaendert
   (Material) und ist die neue Kombination nicht kaufbar, springt die
   letzte Option (Groesse) auf die naechste verfuegbare. Gesucht wird nach
   Abstand, bei Gleichstand die groessere. Darunter erscheint ein kurzer
   Hinweis, damit niemand unbemerkt eine andere Ringgroesse kauft. Der
   Hinweis verschwindet bei der naechsten eigenen Auswahl.

   Eingriff: keiner in die Theme Dateien. Dieses Script hoert nur zu
   ('change' und das Theme Ereignis 'VARIANT_CHANGE') und setzt die neue
   Groesse ueber denselben Weg, den auch ein Klick nimmt. Fehlt etwas,
   passiert schlicht nichts.
   Eingebunden ueber snippets/head-preloader.liquid. Revert: die Zeile
   dort entfernen.
   ================================================================== */
(function () {
  'use strict';
  if (window.__fsVariantJump) { return; }
  window.__fsVariantJump = true;

  var ROW = '[data-js-product-variant-container]';
  var OPT = '[data-option-value-id]';

  var LANG = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var TEXT = {
    de: '{old} ist in dieser Ausführung ausverkauft. Ausgewählt: {new}',
    fr: '{old} est épuisé dans cette finition. Sélectionné : {new}',
    ar: '{old} غير متوفر بهذا الخيار. تم اختيار {new}',
    en: '{old} is sold out in this finish. Selected: {new}'
  };

  function rowsOf(pv) { return Array.prototype.slice.call(pv.querySelectorAll(ROW)); }

  function optionsOf(row) { return Array.prototype.slice.call(row.querySelectorAll(OPT)); }

  function short(el) {
    var v = String(el.value || el.textContent || '').trim();
    var i = v.indexOf(' (');
    return i > 0 ? v.slice(0, i) : v;
  }

  function isAvailable(el) {
    return el.getAttribute('data-available') === 'true' && !el.hasAttribute('data-product-url');
  }

  function removeNote(pv) {
    var n = pv.querySelector('.fs-variant-note');
    if (n && n.parentNode) { n.parentNode.removeChild(n); }
  }

  function showNote(row, oldEl, newEl) {
    var pv = row.closest('product-variants');
    if (pv) { removeNote(pv); }
    var p = document.createElement('p');
    p.className = 'fs-variant-note text-size--small';
    p.setAttribute('role', 'status');
    p.textContent = (TEXT[LANG] || TEXT.en).replace('{old}', short(oldEl)).replace('{new}', short(newEl));
    row.parentNode.insertBefore(p, row.nextSibling);
  }

  function select(el, pv) {
    pv.__fsAutoJump = true;
    if (el.tagName === 'OPTION') {
      var sel = el.closest('select');
      sel.value = el.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      el.checked = true;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* 1. Merken, welche Zeile der Kunde geaendert hat. Capture, damit wir vor
        dem Theme dran sind. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    var pv = t && t.closest ? t.closest('product-variants') : null;
    if (!pv) { return; }
    if (pv.__fsAutoJump) { pv.__fsAutoJump = false; pv.__fsRow = -1; return; }
    var rows = rowsOf(pv);
    var row = t.closest(ROW) || (t.tagName === 'SELECT' ? t : null);
    var idx = rows.indexOf(row);
    pv.__fsRow = idx;
    removeNote(pv);
  }, true);

  /* 2. Nach dem Neuzeichnen pruefen. VARIANT_CHANGE blubbert nicht, ein
        Capture Listener am Dokument bekommt es trotzdem. */
  document.addEventListener('VARIANT_CHANGE', function (e) {
    var pv = e.target;
    if (!pv || pv.tagName !== 'PRODUCT-VARIANTS') { return; }
    var changed = pv.__fsRow;
    pv.__fsRow = -1;
    var rows = rowsOf(pv);
    if (rows.length < 2 || typeof changed !== 'number' || changed < 0 || changed >= rows.length - 1) { return; }
    if (pv.currentVariant && pv.currentVariant.available) { return; }

    var sizeRow = rows[rows.length - 1];
    var opts = optionsOf(sizeRow);
    var cur = -1;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].hasAttribute('data-selected') || opts[i].checked || opts[i].selected) { cur = i; break; }
    }
    if (cur < 0) { return; }

    var pick = null;
    for (var d = 1; d < opts.length && !pick; d++) {
      if (cur + d < opts.length && isAvailable(opts[cur + d])) { pick = opts[cur + d]; }
      else if (cur - d >= 0 && isAvailable(opts[cur - d])) { pick = opts[cur - d]; }
    }
    if (!pick) { return; }

    /* Erst nach dem laufenden Klick ausfuehren. Sonst laeuft die neue
       Auswahl mitten in der Verarbeitung des alten Klicks, und das Theme
       schreibt danach noch die alte Variante in die Adresszeile. */
    var oldEl = opts[cur];
    setTimeout(function () {
      if (pv.currentVariant && pv.currentVariant.available) { return; }
      showNote(sizeRow, oldEl, pick);
      select(pick, pv);
    }, 0);
  }, true);

  var css = document.createElement('style');
  css.textContent = '.fs-variant-note{margin:.6em 0 0;opacity:.7;line-height:1.4}';
  (document.head || document.documentElement).appendChild(css);
})();
